import DWprojects from './DWprojects'
import'.././globals.css'

import { projectsArray } from './projectsArray'


function DWContainer() {

    return(
        <DWprojects projects={projectsArray}/>
    )
}
export default DWContainer